import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import FadeIn from "../components/FadeIn";
import SEO from "../components/SEO";

const WHY_IMG = "https://images.pexels.com/photos/3367850/pexels-photo-3367850.jpeg?auto=compress&cs=tinysrgb&w=1400";

export default function WhyPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="why-page">
      <SEO
        title="Why Dating Apps Feel Broken"
        path="/why-apps-feel-broken"
        description="Dating apps weren't designed for your success. They were designed for engagement. HAEVN takes a fundamentally different approach."
      />
      <Navigation />

      {/* Hero — with image */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src={WHY_IMG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/60" />
        </div>
        <div className="relative z-10 pt-20 pb-16 md:pt-28 md:pb-20 px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <FadeIn>
              <h1 className="font-headline text-4xl sm:text-5xl text-haevn-navy">
                It's not you
              </h1>
            </FadeIn>
          </div>
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      {/* Swipe Fatigue */}
      <section className="py-20 px-6 md:px-12 bg-[#F8F7F5]">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <div className="border-l-4 border-haevn-teal pl-6 py-2">
              <p className="text-lg md:text-xl text-gray-700 font-body leading-relaxed">
                Endless swiping leads to burnout, not better outcomes.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Engagement Model */}
      <section className="py-20 px-6 md:px-12 bg-white">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <div className="border-l-4 border-gray-300 pl-6 py-2">
              <p className="text-lg md:text-xl text-gray-700 font-body leading-relaxed">
                Most platforms are designed to keep you active, not help you leave.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Too Many Options */}
      <section className="py-20 px-6 md:px-12 bg-[#F8F7F5]">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <div className="border-l-4 border-haevn-teal pl-6 py-2">
              <p className="text-lg md:text-xl text-gray-700 font-body leading-relaxed">
                More choice leads to less satisfaction.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      {/* Close */}
      <section className="py-20 px-6 md:px-12 bg-white">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <p className="text-xl md:text-2xl text-haevn-navy font-subhead leading-relaxed">
              What feels like a user problem is actually a system problem.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 md:px-12 bg-haevn-navy">
        <div className="max-w-4xl mx-auto text-center">
          <FadeIn>
            <Link
              to="/how-it-works"
              className="inline-flex items-center gap-2 bg-haevn-gold text-white px-10 py-4 font-subhead text-lg hover:bg-haevn-gold/90 transition-all duration-200 group"
              data-testid="why-cta-btn"
            >
              See how HAEVN works
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </FadeIn>
        </div>
      </section>

      <Footer />
    </div>
  );
}
